import React, { useState, useRef, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import Helmet from 'react-helmet';

import html from './1.htm';

const WysiwygContainer = ({ placeholder }) => {
  const editorRef = useRef(null);
  const [content, setContent] = useState('');

  useEffect(() => {
    async function fetchData() {
      const defaultHtml = await (await fetch(html)).text();

      setContent(defaultHtml);
    }
    fetchData();
  }, []);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: 'Start typings...',
      iframe: true,
      height: '70vh',
      maxHeight: '70vh',
      addNewLine: false,
      hidePoweredByJodit: true,
      width: '100%',
      extraButtons: [
        {
          name: 'Insert Variable',
          tooltip: 'Insert Variable',
          icon: 'menu',
          list: {
            red: 'Red text',
            green: 'Green text',
            blue: 'Blue text',
          },
          exec: (editor, command, control) => {
            const value = control.button.name;

            if (value === 'red') {
              editor.s.insertHTML(`<span style="color:red">${editor.s.html || 'Red text'}</span>`);
            }

            if (value === 'green') {
              editor.s.insertHTML(`<span style="color:green">${editor.s.html || 'Green text'}</span>`);
            }

            if (value === 'blue') {
              editor.s.insertHTML(`<span style="color:blue">${editor.s.html || 'Blue text'}</span>`);
            }
          },
        },
      ],
    }),
    [placeholder],
  );

  const handleBlur = newContent => {
    setContent(newContent);
  };

  return (
    <>
      <Helmet title="Wysiwyg Page" />
      <JoditEditor ref={editorRef} config={config} onBlur={handleBlur} tabIndex={1} value={content} />
    </>
  );
};

export { WysiwygContainer };
export default WysiwygContainer;
